/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <v-card>
    <v-toolbar v-if="toolbar" dense class="sub-header sub-toolbar">
      <v-toolbar-title class="body-2">{{title}}</v-toolbar-title>
    </v-toolbar>
    <v-data-table :headers="headers" :items="data" :loading="loading" hide-actions>
      <template slot="items" slot-scope="myprops">
        <td v-for="header in headers" :key="header.value" :class="enableAlert ? (myprops.item[header.value] ? '' : 'alert') :'' " class="text-xs-left">{{ myprops.item[header.value] !== null ? myprops.item[header.value] :
          errorMessage }}</td>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  props: ["headers", "data", "title", "loading", "toolbar", "enableAlert", "errorMessage"]
};
</script>

<style scope>
table.v-table tbody td,
table.v-table tbody th {
  height: 20px;
}

table.v-table thead tr {
    height: 36px;
}

.alert {
  /* color:white; */
  color:red;
  /* background-color: red */
  
}

table.v-table tbody td:not(:nth-child(1)),
table.v-table thead th:not(:nth-child(1)) {
  padding: 0 6px;
}
</style>

